<template>
  <div v-if="glami.active" class="mb-1">
    <div class="form-check">
      <input id="dm_glami_consent_checkbox" type="checkbox" class="form-check-input" :checked="glami.checked" @change="updateValue">
      <label class="form-check-label" for="dm_glami_consent_checkbox">
        {{ glami.text }}
        <span v-if="glami.showLink">
          <a :href="glami.link" target="_blank" class="dm_glami_consent_link">{{ glami.linkName }}</a>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      glami: state => state.dmGlamiConsent,
    }),
  },
  methods: {
    updateValue (e) {
      this.$store.commit('dmGlamiConsent/SET', e.target.checked);
    }
  },
};
</script>

<style scoped>
  .dm_glami_consent_link {
    text-decoration: underline;
  }
</style>
